import script from "./AlbumCard.vue?vue&type=script&setup=true&lang=js"
export * from "./AlbumCard.vue?vue&type=script&setup=true&lang=js"

import "./AlbumCard.vue?vue&type=style&index=0&id=43911c98&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43911c98"]])

export default __exports__